import { Col, Form, Input, InputNumber, Row, Typography } from 'antd';
import { InputDate } from 'Components/Inputs/InputDate';
import { SelectPlus } from 'Components/SelectPlus';

const { Text } = Typography;

const componentByType = {
  string: (field) => <Input allowClear={!field.required} />,
  number: (_) => <InputNumber controls={false} style={{ width: '100%' }} />, // allowClear no soportado en InputNumber
  password: (field) => <Input.Password allowClear={!field.required} />,
  email: (field) => <Input allowClear={!field.required} />,
  date: (field) => <InputDate allowClear={!field.required} />,
  select: (field) => (
    <SelectPlus
      options={field.options}
      allowClear={!field.required}
      parseNumericValue // Se activa parseNumericValue para convertir a número los valores numéricos recibidos como strings. Esto permite que coincidan con opciones numéricas definidas en los schemas y se muestre así el 'label' correcto
      popupMatchSelectWidth={false}
      dropdownStyle={{ maxWidth: 300 }}
    />
  ),
};

export const CredentialsForm = ({ form, initialCredentials, credentialsSchema, onFinish, readOnly, onSedeChange }) => {
  return (
    <Form
      form={form}
      onFinish={onFinish}
      initialValues={initialCredentials}
      disabled={readOnly}
      layout='vertical'
      clearOnDestroy
    >
      <Row gutter={16} align='bottom'>
        {credentialsSchema.fields.map((field) => {
          const isSede = field.key === 'sede';

          return (
            <Col span={12} key={field.key}>
              <Form.Item
                name={field.key}
                label={<Text strong>{field.label}</Text>}
                tooltip={field.helpText}
                rules={[
                  { required: field.required },
                  ...(field.type === 'email' ? [{ type: 'email' }] : []),
                ]}
              >
                {isSede && field.type === 'select' ? (
                  <SelectPlus
                    options={field.options}
                    onChange={onSedeChange}
                    disabled={true}
                    parseNumericValue
                    popupMatchSelectWidth={false}
                    dropdownStyle={{ maxWidth: 300 }}
                  />
                ) : (
                  (componentByType[field.type] || componentByType.string)(field)
                )}
              </Form.Item>
            </Col>
          );
        })}
      </Row>
    </Form>
  );
};
